import { render, staticRenderFns } from "./InsurancePlansPage.vue?vue&type=template&id=1329b43e&scoped=true"
import script from "./InsurancePlansPage.vue?vue&type=script&lang=js"
export * from "./InsurancePlansPage.vue?vue&type=script&lang=js"
import style0 from "./InsurancePlansPage.vue?vue&type=style&index=0&id=1329b43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329b43e",
  null
  
)

export default component.exports